var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494.72,
    height: 136.252,
    viewBox: "0 0 494.72 136.252",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-logo",
    transform: "translate(-0.013 1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tail",
    d: "M34.78,129.63c-21.94-7.24-50-44-24.86-91.62,26.65-50.44,77.93,7,99.9-36.85a2.11,2.11,0,0,1,3.34-.58c23.64,23.47,25.87,109-48,119C65.19,119.62,43.39,132.47,34.78,129.63Z",
    transform: "translate(0 -1)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AnimalBody"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M103.65,51.59c1.91,7.14-9.74,25.59-28.8,30.7S37.73,81.93,34.56,70.1s9.73-25.59,28.8-30.7S101.73,44.44,103.65,51.59Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M24.15,135.24a157.116,157.116,0,0,1-1.1-18.74c0-40.3,14.73-73,32.87-73,17.62,0,50.42,28.77,64,91.75",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M44.65,31.45c2.48-1.39,10.45,1.18,14.17,7.78s3.42,13.84-.68,16.15S47.69,54.21,44,47.6,42.18,32.85,44.65,31.45Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "AnimalEye",
    d: "M68.24,45.55c2.9-.46,5.52.81,6,3.71a5.321,5.321,0,0,1-10.51,1.67C63.25,48,65.34,46,68.24,45.55Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 64.98,
    height: 40.08,
    rx: 5.67,
    transform: "translate(34.78 85.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M39.61,125.59H94.93a4.82,4.82,0,0,1,4.82,4.82h0a4.83,4.83,0,0,1-4.83,4.83H39.61a4.83,4.83,0,0,1-4.83-4.83h0a4.82,4.82,0,0,1,4.82-4.82Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptopLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M57.09,102.73H77.45c.5,1.29.18,11-3.29,13.44a25.56,25.56,0,0,1-6.87,3.21h0a25.43,25.43,0,0,1-6.86-3.21C56.91,113.71,56.6,104,57.09,102.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M79,103H55.59c-.57-.57-.21-4.86,3.78-6a60.274,60.274,0,0,1,7.88-1.43h0A60.272,60.272,0,0,1,75.13,97C79.16,98.14,79.52,102.43,79,103Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M69,96.06H65.54c-.09-.23,0-1.91.56-2.33a2.61,2.61,0,0,1,2.34,0C69,94.15,69.09,95.83,69,96.06Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AnimalHands"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M88.09,125.86c-2.3-7.19,7.93-2.44,12.43-15.56,3.16-9.19,16.34,13.26,7.43,17.13S89,128.83,88.09,125.86Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M45.12,124.6c.46-5.88-6.46-.44-12.24-9.59-4-6.41-10,13-2.56,14.34S44.94,127,45.12,124.6Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M29.063-56.875h9.844v39.883q0,8.164-5.1,12.969T20.352.781Q11.445.781,6.6-3.711t-4.844-12.5H11.6q0,4.531,2.246,6.816t6.5,2.285A8.1,8.1,0,0,0,26.7-9.746a10.525,10.525,0,0,0,2.363-7.285ZM47.5-21.523a24.922,24.922,0,0,1,2.461-11.191,17.973,17.973,0,0,1,6.914-7.656,19.481,19.481,0,0,1,10.234-2.676q8.555,0,13.887,5.508T86.758-22.93L86.8-20.7a25.145,25.145,0,0,1-2.4,11.172A17.757,17.757,0,0,1,77.52-1.914,19.624,19.624,0,0,1,67.188.781q-8.945,0-14.316-5.957T47.5-21.055Zm9.492.82q0,6.523,2.7,10.215a8.762,8.762,0,0,0,7.5,3.691,8.667,8.667,0,0,0,7.48-3.75q2.676-3.75,2.676-10.977,0-6.406-2.754-10.156a8.793,8.793,0,0,0-7.48-3.75,8.713,8.713,0,0,0-7.383,3.691Q56.992-28.047,56.992-20.7Zm74.922,0q0,9.844-4.395,15.664A14.315,14.315,0,0,1,115.43.781q-7.422,0-11.562-5.352L103.4,0H94.8V-60H104.3v21.8a13.739,13.739,0,0,1,11.055-4.844A14.478,14.478,0,0,1,127.5-37.3q4.414,5.742,4.414,16.055Zm-9.492-.82q0-6.875-2.422-10.312a8.065,8.065,0,0,0-7.031-3.437q-6.172,0-8.672,5.391v17.422a8.9,8.9,0,0,0,8.75,5.508,8,8,0,0,0,6.875-3.32q2.422-3.32,2.5-10.039Zm41.133,10.039a4.3,4.3,0,0,0-2.09-3.867,22.227,22.227,0,0,0-6.934-2.344,35.643,35.643,0,0,1-8.086-2.578q-7.109-3.437-7.109-9.961a11.25,11.25,0,0,1,4.609-9.141,18.222,18.222,0,0,1,11.719-3.672q7.578,0,12.246,3.75a11.9,11.9,0,0,1,4.668,9.727h-9.492a5.85,5.85,0,0,0-2.031-4.551,7.784,7.784,0,0,0-5.391-1.816,8.412,8.412,0,0,0-5.1,1.445,4.556,4.556,0,0,0-1.973,3.867,3.847,3.847,0,0,0,1.836,3.4q1.836,1.211,7.422,2.441a35.133,35.133,0,0,1,8.77,2.93,12.418,12.418,0,0,1,4.727,4.082,10.41,10.41,0,0,1,1.543,5.781,11.012,11.012,0,0,1-4.727,9.238Q163.437.781,155.781.781a21.855,21.855,0,0,1-9.258-1.875A15.237,15.237,0,0,1,140.2-6.25a12.205,12.205,0,0,1-2.266-7.07h9.219a6.689,6.689,0,0,0,2.539,5.176A9.866,9.866,0,0,0,155.9-6.328a9.6,9.6,0,0,0,5.7-1.426A4.413,4.413,0,0,0,163.555-11.484ZM214.844-24.1H191.953V0H182.07V-56.875H218.2v7.969h-26.25v16.914h22.891Zm6.856,2.578a24.922,24.922,0,0,1,2.461-11.191,17.973,17.973,0,0,1,6.914-7.656,19.481,19.481,0,0,1,10.234-2.676q8.555,0,13.887,5.508t5.762,14.609L261-20.7a25.145,25.145,0,0,1-2.4,11.172,17.757,17.757,0,0,1-6.875,7.617,19.624,19.624,0,0,1-10.332,2.7q-8.945,0-14.316-5.957T221.7-21.055Zm9.492.82q0,6.523,2.7,10.215a8.762,8.762,0,0,0,7.5,3.691,8.667,8.667,0,0,0,7.48-3.75q2.676-3.75,2.676-10.977,0-6.406-2.754-10.156a8.793,8.793,0,0,0-7.48-3.75,8.713,8.713,0,0,0-7.383,3.691Q231.192-28.047,231.192-20.7Zm59.961-12.891a23.489,23.489,0,0,0-3.867-.312q-6.523,0-8.789,5V0H269V-42.266h9.063l.234,4.727a10.7,10.7,0,0,1,9.531-5.508,8.886,8.886,0,0,1,3.359.547Z",
    transform: "translate(134.08 108.11)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M16.211,0H6.367V-56.875h9.844ZM68.653-48.906H50.919V0h-9.8V-48.906H23.536v-7.969H68.653Z",
    transform: "translate(426.08 108.11)",
    fill: "#e87d4a"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.76f20e1b.svg";
export { ForwardRef as ReactComponent };